// extracted by mini-css-extract-plugin
module.exports = {"root":"layout-module--root--F125N","asof":"layout-module--asof--2t9lo","philosophy":"layout-module--philosophy--2LLCe"};